const formatDefaultMessage = (defaultMessage, values = undefined) => {
  if (!values) {
    return defaultMessage;
  }

  return String(defaultMessage).replace(/\{(\w+)\}/g, (match, key) => {
    const value = values?.[key];
    return value == null ? match : String(value);
  });
};

export const formatMessengerV2Message = (intl, id, defaultMessage, values = undefined) => {
  if (intl && typeof intl.formatMessage === 'function') {
    const messages = intl.messages || null;
    if (
      messages &&
      Object.prototype.hasOwnProperty.call(messages, id) === false &&
      defaultMessage != null
    ) {
      return formatDefaultMessage(defaultMessage, values);
    }

    return intl.formatMessage({ id, defaultMessage }, values);
  }

  return formatDefaultMessage(defaultMessage, values);
};
